(function () {
  if (window.__albeuxSpeed) return;
  window.__albeuxSpeed = true;

  /* ---------- A. Colour / size taps: the answer is already waiting ----------
     The product page asks the shop for the page of each colour only after the tap. Here every colour and size is fetched in the
     background first (a few at a time, when the browser is idle), so a tap is answered from memory in a blink. */
  var nativeFetch = window.fetch ? window.fetch.bind(window) : null;
  var cache = new Map();
  function keyOf(u) { try { var x = new URL(u, location.href); return x.origin === location.origin ? x.pathname + x.search : ''; } catch (e) { return ''; } }
  function isVariantUrl(u) { var k = keyOf(u); return !!k && /[?&]option_values=/.test(k); }

  if (nativeFetch) {
    window.fetch = function (input, init) {
      try {
        var u = typeof input === 'string' ? input : (input && input.url);
        var method = ((init && init.method) || (input && input.method) || 'GET').toUpperCase();
        if (u && method === 'GET' && isVariantUrl(u)) {
          var hit = cache.get(keyOf(u));
          if (hit) {
            var signal = init && init.signal;
            return new Promise(function (resolve, reject) {
              if (signal && signal.aborted) { reject(new DOMException('Aborted', 'AbortError')); return; }
              if (signal) signal.addEventListener('abort', function () { reject(new DOMException('Aborted', 'AbortError')); }, { once: true });
              hit.then(function (r) { resolve(r.clone()); }, function () { cache.delete(keyOf(u)); nativeFetch(input, init).then(resolve, reject); });
            });
          }
        }
      } catch (e) {}
      return nativeFetch(input, init);
    };
  }

  function warm(url) {
    var k = keyOf(url);
    if (!k || cache.has(k) || !nativeFetch) return;
    if (cache.size >= 60) cache.delete(cache.keys().next().value);
    var p = nativeFetch(url, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error('x'); return r; });
    p.catch(function () { cache.delete(k); });
    cache.set(k, p);
  }

  function planFor(vp) {
    var base = (vp.dataset.productUrl || '').split('?')[0];
    if (!base) return [];
    var fs = Array.prototype.slice.call(vp.querySelectorAll('fieldset'));
    if (!fs.length) return [];
    var chosen = fs.map(function (f) { var c = f.querySelector('input:checked'); return c ? c.dataset.optionValueId : null; });
    var urls = [];
    fs.forEach(function (f, i) {
      Array.prototype.slice.call(f.querySelectorAll('input')).forEach(function (inp) {
        var ids = chosen.slice();
        ids[i] = inp.dataset.optionValueId;
        for (var j = 0; j < ids.length; j++) if (!ids[j]) return;
        urls.push(base + '?option_values=' + ids.join(','));
      });
    });
    return urls;
  }

  function warmPickers() {
    var vps = document.querySelectorAll("main[data-template^='product'] variant-picker[data-template-product-match='true']");
    var queue = [];
    vps.forEach(function (vp) { queue = queue.concat(planFor(vp)); });
    var n = 0;
    (function next() {
      if (n >= queue.length) return;
      warm(queue[n++]);
      setTimeout(next, 90);
    })();
  }
  /* ALBEUX (1 Nov 2026, smooth): while the product page is still zooming in, this background work waits its turn, so nothing can slow or stutter the zoom.
     It gives up waiting after 3 seconds. */
  function afterZoom(go) {
    var de = document.documentElement;
    if (!de.classList.contains('alb-zooming')) { go(); return; }
    var n = 0;
    var t = setInterval(function () {
      if (!de.classList.contains('alb-zooming') || ++n > 30) { clearInterval(t); go(); }
    }, 100);
  }
  function later(fn) {
    afterZoom(function () {
      if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: 1500 }); else setTimeout(fn, 600);
    });
  }

  /* ---------- B. Product photos: decode them before the swipe, not during it ----------
     ALBEUX (1 Nov 2026): the first photograph (the one on screen, which the zoom has just handed over to) is left completely alone: changing the loading or decoding of a
     picture that is on screen can make it flash for a frame. Only the other photographs are prepared. */
  function warmGallery() {
    var imgs = Array.prototype.slice.call(document.querySelectorAll("main[data-template^='product'] media-gallery img")).filter(function (img) {
      try { return !img.closest('slideshow-slide:first-child, .media-gallery__grid > *:first-child'); } catch (e) { return true; }
    }).slice(0, 8);
    var i = 0;
    (function next() {
      if (i >= imgs.length) return;
      var img = imgs[i++];
      try {
        img.decoding = 'async';
        if (img.loading === 'lazy') img.loading = 'eager';
        var d = img.decode ? img.decode() : Promise.resolve();
        d.catch(function () {}).then(function () { setTimeout(next, 60); });
      } catch (e) { setTimeout(next, 60); }
    })();
  }

  function start() {
    if (!document.querySelector("main[data-template^='product']")) return;
    later(warmPickers);
    later(warmGallery);
  }
  if (document.readyState === 'complete') start(); else window.addEventListener('load', start);
  document.addEventListener('shopify:section:load', start);
  /* After a tap the other combinations change, so prepare those too */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-picker')) setTimeout(function () { later(warmPickers); later(warmGallery); }, 250);
  }, true);
})();
